import {
  ActionIcon,
  Anchor,
  Checkbox,
  Popover,
  Stack,
  Tooltip,
} from '@mantine/core';
import { BiFilterAlt } from 'react-icons/bi';
import {
  useJobDetailStore,
  useActiveCandidateFilters,
} from '@company/pages/JobOverview/DetailV2/stores/jobDetailStore';

export default function FilterPopover() {
  const candidateFilters = useActiveCandidateFilters();
  const setCandidateFilters = useJobDetailStore(
    (state) => state.setCandidateFilters
  );

  const hasActiveFilters = Boolean(
    candidateFilters.gender?.length || candidateFilters.country?.length
  );

  // Empty selection is stored as undefined so the key drops out of the API params.
  const updateFilter = (key: 'gender' | 'country', values: string[]) =>
    setCandidateFilters({
      ...candidateFilters,
      [key]: values.length ? values : undefined,
    });

  const clearFilters = () =>
    setCandidateFilters({
      ...candidateFilters,
      gender: undefined,
      country: undefined,
    });

  return (
    <Popover width={220} position="bottom-end" withArrow shadow="md">
      <Popover.Target>
        <Tooltip label="Filter" withArrow>
          <ActionIcon
            variant={hasActiveFilters ? 'filled' : 'light'}
            color={hasActiveFilters ? 'brandYellow' : undefined}
            size={40}
            c="var(--black)"
            aria-label="Filter"
          >
            <BiFilterAlt size={20} />
          </ActionIcon>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="md">
          <Checkbox.Group
            label="Gender"
            value={candidateFilters.gender ?? []}
            onChange={(values) => updateFilter('gender', values)}
          >
            <Stack gap="xs" mt="xs">
              <Checkbox value="MALE" label="Male" />
              <Checkbox value="FEMALE" label="Female" />
            </Stack>
          </Checkbox.Group>

          <Checkbox.Group
            label="Country"
            value={candidateFilters.country ?? []}
            onChange={(values) => updateFilter('country', values)}
          >
            <Stack gap="xs" mt="xs">
              <Checkbox value="UNITED_STATES" label="USA" />
              <Checkbox value="CANADA" label="Canada" />
            </Stack>
          </Checkbox.Group>

          {hasActiveFilters && (
            <Anchor
              component="button"
              size="xs"
              c="dimmed"
              onClick={clearFilters}
            >
              Clear filters
            </Anchor>
          )}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
